import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { TableSkeletonRows } from '@/components/ui/table-skeleton'
import { customerTabHref } from '../../../../lib/customerTabs'
import { formatDate } from '../../../../lib/formatters'
import { useCoiRequests } from '../../../../models/coiRequest'

export function CoiRequests() {
  const { rows, isLoading } = useCoiRequests()
  const navigate = useNavigate()

  return (
    <>
      <Helmet>
        <title>COI Requests</title>
      </Helmet>
      <div className="flex flex-col gap-5">
        <div className="mb-2 text-2xl font-semibold">COI Requests</div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="font-semibold">Org</TableHead>
              <TableHead className="font-semibold">Certificate Holder</TableHead>
              <TableHead className="font-semibold">Email</TableHead>
              <TableHead className="font-semibold">Requested</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading && <TableSkeletonRows columns={4} />}
            {!isLoading && rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} className="pt-5 text-center">
                  No open COI requests
                </TableCell>
              </TableRow>
            )}
            {rows.map((row) => (
              <TableRow
                key={row.id}
                className="cursor-pointer"
                onClick={() => navigate(customerTabHref(row.orgId, 'coi'))}
              >
                <TableCell className="font-medium">{row.orgName}</TableCell>
                <TableCell>{row.holderName}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{formatDate(row.dateCreated)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  )
}
